import React from 'react';
import { MessageCircle, BookOpen, Play, Lightbulb, Bug } from 'lucide-react';
import { useOnboarding } from '../../features/onboarding';

const HelpSection = () => {
  const { openOnboarding } = useOnboarding();
  
  const helpOptions = [
    {
      id: 'support',
      title: 'Talk to Support',
      description: 'Chat with our support team for immediate help',
      icon: MessageCircle,
      color: 'from-blue-500 to-blue-600',
      action: () => {
        console.log('Support chat will be implemented');
        // TODO: Implement chatbot modal
      }
    },
    {
      id: 'docs',
      title: 'Visit Help Docs',
      description: 'Browse our comprehensive documentation',
      icon: BookOpen,
      color: 'from-purple-500 to-purple-600',
      action: () => {
        console.log('Help docs will be implemented');
        // TODO: Link to help documentation
      }
    },
    {
      id: 'tutorial',
      title: 'Replay Onboarding',
      description: 'Walk through the setup tutorial again',
      icon: Play,
      color: 'from-green-500 to-green-600',
      action: () => {
        openOnboarding();
      }
    },
    {
      id: 'tip',
      title: 'Share a Tip',
      description: 'Tell us about a feature you love or want to see',
      icon: Lightbulb,
      color: 'from-yellow-500 to-yellow-600',
      action: () => {
        console.log('Share tip will be implemented');
        // TODO: Open feedback form
      }
    },
    {
      id: 'bug',
      title: 'Report a Bug',
      description: 'Let us know if something isn\'t working right',
      icon: Bug,
      color: 'from-red-500 to-red-600',
      action: () => {
        console.log('Bug report will be implemented');
        // TODO: Open bug report form
      }
    }
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Help & Support</h2>
        <p className="text-gray-600 mt-2">
          Get assistance, learn more, or share feedback
        </p>
      </div>

      {/* Help Options Grid */}
      <div className="grid gap-4">
        {helpOptions.map((option) => {
          const Icon = option.icon;
          
          return (
            <button
              key={option.id}
              onClick={option.action}
              className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-all hover:border-gray-300 text-left group"
            >
              <div className="flex items-start space-x-4">
                {/* Icon */}
                <div className={`w-12 h-12 rounded-lg bg-gradient-to-br ${option.color} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}>
                  <Icon className="text-white" size={24} />
                </div>
                
                {/* Content */}
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-semibold text-gray-900 group-hover:text-gray-700">
                    {option.title}
                  </h3>
                  <p className="text-sm text-gray-600 mt-1">
                    {option.description}
                  </p>
                </div>

                {/* Arrow indicator */}
                <div className="flex-shrink-0 text-gray-400 group-hover:text-gray-600 group-hover:translate-x-1 transition-all">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </button>
          );
        })}
      </div>

      {/* Contact Info */}
      <div className="mt-8 p-6 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg border border-gray-200">
        <h3 className="text-sm font-semibold text-gray-900 mb-2">Need More Help?</h3>
        <p className="text-sm text-gray-600">
          Email us at{' '}
          <a 
            href="mailto:support@swirl.app" 
            className="text-blue-600 hover:text-blue-700 font-medium"
          >
            support@swirl.app
          </a>
          {' '}or reach out on social media.
        </p>
      </div>
    </div>
  );
};

export default HelpSection;

